export default "__VITE_ASSET__DSg16sx3__"